import './Cart.css';
import { Button, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { CartContext } from '../../store/CartContext';
import CartItem from '../../components/cart/CartItem';
import { StoreData } from '../../data/store-data';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckoutContext, FlowsOptions } from '../../store/CheckoutContext';

interface Props {}

const Cart: React.FC<Props> = props => {
  const { cart } = useContext(CartContext);
  const { flow } = useContext(CheckoutContext);
  const cartSize = StoreData.getCartSize(cart);

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="Cart">
      <Typography variant="h5">Your Cart</Typography>
      <Typography variant="body2" color="textSecondary">
        ({cartSize} {cartSize === 1 ? 'item' : 'items'})
      </Typography>
      <div className="cart-items">
        {cart.map((item, index) => (
          <CartItem key={index} cartItem={item} />
        ))}
      </div>
      <div className="total">
        <span className="label">Total:</span>
        <span className="amount">
          ${cart.reduce((total, cartItem) => total + cartItem.quantity * cartItem.item.price, 0).toFixed(2)}
        </span>
      </div>
      <div className="buttons">
        {/*<Button variant="outlined" onClick={() => navigate('/checkout')}>*/}
        <Button
          variant="outlined"
          className="margin-bottom"
          onClick={() => {
            if (location.pathname.includes('demo')) {
              navigate('/demo/checkout-iframe');
            } else {
              switch (flow) {
                case FlowsOptions.terminal:
                  navigate('/terminal');
                  break;
                case FlowsOptions.steps:
                  navigate('/checkout-steps');
                  break;
                case FlowsOptions.withoutOrderId:
                  navigate('/checkout-iframe-without-order-id');
                  break;
                case FlowsOptions.iframe:
                  navigate('/checkout-iframe');
                  break;
                default:
                  navigate('/checkout-iframe');
                  break;
              }
            }
          }}
        >
          Checkout
        </Button>
        {/*<Button variant="outlined" className="margin-bottom" onClick={() => navigate('/checkout')}>*/}
        {/*  Checkout Card*/}
        {/*</Button>*/}
        {/*<Button variant="outlined" onClick={() => navigate('/checkout-hosted-fields')}>*/}
        {/*  Checkout Hosted Fields*/}
        {/*</Button>*/}
      </div>
    </div>
  );
};

export default Cart;
